<template>
	<v-card>
		<v-card-title>
			<h2>Kody DAC</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<div>
			<v-flex xs5>
				<v-layout wrap>
							<v-flex xs9>
								<v-subheader>{{isDacCodeEnabled ?
									"Kody DAC" :
									"Brak kodów DAC"}}
								</v-subheader>
							</v-flex>
							<v-flex xs3>
								<v-switch aria-label="label for switch"
									v-model="isDacCodeEnabled"
									@change="updateStatus"
								></v-switch>
							</v-flex>
				</v-layout>
			</v-flex>
		</div>
		<div v-if="isDacCodeEnabled">
		<div>
			<v-btn
				color="primary" dark class="ml-3 mt-3" @click="addCodeDialog = true">Dodaj kod
			</v-btn>
		</div>
		<div>
			<v-btn
				color="primary" dark class="ml-3 mb-2" @click="copyCodes">Zaimportuj wszystkie kody
			</v-btn>
		</div>

		<egranty-table
			:items="codes"
			:headers="headers"
			:row-actions="actions"
			export-sorted-by-field-name="code"
			:table-name="'Kody DAC w tym naborze'"
			@delete="removeCode"
		></egranty-table>
	</div>

		<v-dialog v-model='addCodeDialog' persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">Dodaj kod DAC</span>
				</v-card-title>
				<v-card-text>
					<v-layout row>
						<v-select
							label="Kod"
							:items="codesToAdd"
							item-text="viewData"
							item-value="id"
							aria-label="DAC code"
							v-model="codeToAddId">
						</v-select>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn v-if="codeToAddId !== null"
						color="primary"
						@click="addCode">
						Zapisz
					</v-btn>
					<v-btn
						color="blue"
						@click="addCodeDialog = false">
						Anuluj
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-card>
</template>

<script>
	import EgrantyTable from "../../../../genericComponents/EgrantyTable";
	import {AgencyContest} from "../../../../api/generated/AgencyContest";

	export default {
		name: "AgencyDACCodes",
		components: {EgrantyTable},

		data() {
			return {
				codes: [],
				codesToAdd: [],
				addCodeDialog: false,
				codeToAddId: null,
				headers: [
					{text: "Kod", value: "code"},
					{text: "Opis", value: "description"}
				],
				actions: [
					{name: "delete", icon: "delete"}
				],
				isDacCodeEnabled: true,
			};
		},

		watch: {
			addCodeDialog (val) {
				if (!val) this.codeToAddId = null;
			}
		},

		methods: {
			update () {
				AgencyContest.getDacCodes(this, this.$route.params.id, successResponse => {
						this.codes = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy kodów DAC", errorResponse);
					});

				AgencyContest.getDacCodesAvailableToAdd(this, this.$route.params.id, successResponse => {
						this.codesToAdd = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy kodów DAC", errorResponse);
					});

			},

			copyCodes () {
				this.$confirm("Czy na pewno chcesz zaimportować wszystkie kody?", {
					title: 'Uwaga',
					color: 'blue',
					width: 500
				})
					.then(response => {
						if (response) {
							AgencyContest.postDacCodes(this, this.$route.params.id, successResponse => {
									this.$messagesBus.$emit("success", "Kody zostały pomyślnie zaimportowane", successResponse);
									this.update();
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się zaimportować kodów", errorResponse);
								});
						}
					});
			},

			addCode () {
				AgencyContest.putDacCodes(this, this.$route.params.id, this.codeToAddId, successResponse => {
						this.addCodeDialog = false;
						this.$messagesBus.$emit("success", "Kod został pomyślnie dodany", successResponse);
						this.update();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się dodać kodu", errorResponse);
					});
			},

			removeCode (item) {
				this.$confirm("Czy na pewno chcesz usunąć kod?", {
					icon: 'delete',
					title: 'Uwaga',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							AgencyContest.deleteDacCodes(this, item.id, successResponse => {
									this.$messagesBus.$emit("success", "Kod został pomyślnie usunięty", successResponse);
									this.update();
								},
								errorResponse => {
									this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
								});
						}
					});
			},

			updateStatus () {
				AgencyContest.putDacCodesStatus(this, this.$route.params.id, this.isDacCodeEnabled, successResponse => {
						this.$messagesBus.$emit("success", "Zaktualizowano status kodów DAC", successResponse);
						this.getStatus();		
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
						this.getStatus();
					});
			},

			getStatus () {
				AgencyContest.getDacCodesStatus(this, this.$route.params.id, successResponse => {
						this.isDacCodeEnabled = successResponse;
						if(this.isDacCodeEnabled) this.update();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować statusu kodów DAC", errorResponse);
					});
			},
		},

		mounted () {
			this.getStatus();
		}
	};
</script>

<style scoped>

</style>
